import Vue from 'vue'
import i18n from 'vue-i18n'

import { BaseButton, ButtonTypes } from './types'

/** Базовый билдер кнопки, его экземпляр передается в редактор сообщений */
export default abstract class BaseButtonBuilder {
  $i18n: i18n

  abstract type: ButtonTypes | string

  abstract titleKey: string

  abstract data: BaseButtonViewData

  abstract icon: string

  abstract setupView: typeof Vue
  abstract buttonView: typeof Vue

  buttonProps: Record<string, any> | null

  constructor(i18n: i18n, buttonProps?: Record<string, any> | null) {
    this.$i18n = i18n

    this.buttonProps = buttonProps ?? null
  }

  abstract getData(selectedButton?: BaseButtonViewData): BaseButtonViewData

  refreshData(): void {
    this.data = this.getData()
  }

  abstract create(): BaseButton
}

/**
 * Интерфейс объекта для сбора данных от пользователя.
 * Промежуточное звено между моментом выбора типа кнопки и непосредственного создания кнопки.
 * Собирает данные от пользователя и используя их, создает кнопку
 * */
export interface BaseButtonViewData {
  text: string
}
